/**
 * Non WooCommerce
 *
 */
import Scroll from "./animations/scroll";
import Heights from "./matchHeight";
import Sliders from "./sliders";
import Stagger from "./animations/stagger";
import { fade } from "./animations/effects/fade";
import Count from "./animations/count";
import Alpine from "alpinejs";
import ajax from "@imacrayon/alpine-ajax";
import Clipboard from "@ryangjchandler/alpine-clipboard";
import ServiceCompanies from "./serviceCompanies";
import Countdown from "./countdown";
import Confetti from "./confetti";

window.addEventListener("DOMContentLoaded", () => {
	// Array.prototype.forEach.call(document.querySelectorAll("*"), (element) => {
	// 	element.style.outline = "1px solid #" + (Math.random() * 0xffffff << 0).toString(16)
	// })

	window.Alpine = Alpine;
	Alpine.plugin(ajax);
	Alpine.plugin(Clipboard);
	Alpine.start();

	Heights();
	Sliders();
	Count();
	ServiceCompanies();
	Countdown();
	Confetti();

	new Scroll(
		document.querySelectorAll("[data-fade-in]"),
		{
			opacity: 0,
			top: 20,
			position: "relative",
		},
		{
			opacity: 1,
			top: 0,
			duration: 1,
		}
	);

	const editable = document.querySelectorAll(".prose");
	if (editable.length) {
		editable.forEach((el) => {
			new Stagger(el.children, fade.from, fade.to);
		});
	}

	const check = setInterval(() => {
		const element = document.querySelector(".img-comp-slider");
		if (element) {
			clearInterval(check);
			const arrow = document.createElement("ion-icon");
			arrow.setAttribute("name", "swap-horizontal");
			arrow.classList.add(
				"absolute",
				"left-1/2",
				"top-1/2",
				"-translate-x-1/2",
				"-translate-y-1/2",
				"text-2xl",
				"z-10"
			);
			element.appendChild(arrow);
		}
	}, 300);
});
